module.exports = __webpack_public_path__ + "img/ph2supp3.6fa781ed.png";